import { Anchor } from '@ampol/design-system';
import { useSelector } from 'react-redux';
import ErrorPage from '../../containers/error-page/ErrorPage';
import Links from 'constants/links';
import { AccessVerifier } from '../../utilities/access-verifier';

const RouteGuard = ({ component: Component, accessRoles, portalAccess, ...rest }) => {
  const { loggedInUserError } = useSelector((state) => state.userStore);
  const hasAccess = AccessVerifier(portalAccess, accessRoles);

  if (!hasAccess && loggedInUserError) {
    return (
      <ErrorPage
        heading={"Sorry you don't have access to that resource"}
        errorCode={403}
        message={
          <span>
            We&apos;re sorry about that. Please <Anchor href={Links.CONTACT_US}>contact us</Anchor> to request access.
          </span>
        }
      />
    );
  }
else if(hasAccess)
  return Component ? <Component {...rest} /> : null;
};

export default RouteGuard;